var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIconYellow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.5225 17.5225 22 12 22C6.4775 22 2 17.5225 2 12C2 6.4775 6.4775 2 12 2C17.5225 2 22 6.4775 22 12Z",
    fill: "#FDE68A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11H13V16.5H11V11ZM13.25 8.25C13.25 8.9395 12.6895 9.5 12 9.5C11.3105 9.5 10.75 8.9395 10.75 8.25C10.75 7.5605 11.3105 7 12 7C12.6895 7 13.25 7.5605 13.25 8.25Z",
    fill: "#92400E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconYellow);
export default __webpack_public_path__ + "static/media/info-icon-yellow.5b9ab48eb23812e63570cbd06d4d9032.svg";
export { ForwardRef as ReactComponent };